import styled from "@emotion/styled";
import { css, Typography } from "@mui/material";
import { mobile } from "commons/styled.components";
import { COLORS } from "utils/colors";

export const SignupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const SignupBaseForm = styled.form`
  width: 45%;
  padding: 2.5rem 0 1rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  ${mobile(css`
    width: 90%;
    padding: 1.5rem 0 1rem;
  `)};
`;

export const BrandsBannerSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 3rem 2rem;
  background: ${COLORS.BRAND_LIGHT_BACKGROUND};
  text-align: center;

  ${mobile(css`
    padding: 2rem 1rem;
    background: ${COLORS.BRAND_WHITE_BACKGROUND};
  `)};
`;

export const BrandsBannerTitle = styled(Typography)`
  color: ${COLORS.LOGIN_PRIMARY};
  font-size: 24px;
  font-weight: 600;

  ${mobile(css`
    font-size: 20px;
  `)};
`;

export const BrandsBannerSubtitle = styled(Typography)`
  color: ${COLORS.LOGIN_SECONDARY};
  font-size: 15px;
  margin-top: 8px;
`;

export const BrandsLogoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 56px;
  margin-top: 28px;

  ${mobile(css`
    gap: 32px;
    margin-top: 20px;
    transform: scale(0.85);
  `)};
`;

export const BrandLogoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;

  ${mobile(css`
    height: 30px;
  `)};
`;

export const BrandLogoImage = styled.img<{ blend?: boolean }>`
  height: 100%;
  width: auto;
  object-fit: contain;
  opacity: 0.9;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  ${(props) =>
    props.blend &&
    css`
      mix-blend-mode: multiply;
    `}

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }
`;

export const HowItWorksSection = styled.div`
  position: relative;
  // width: 100%;
  box-sizing: border-box;
  padding: 2.5rem 2rem;
  overflow: hidden;

  ${mobile(css`
    padding: 1.5rem 1rem;
  `)};
`;

export const HowItWorksHeader = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 560px;
  margin: 0 auto 24px;
`;

export const HowItWorksTitle = styled(Typography)`
  color: ${COLORS.LOGIN_PRIMARY};
  font-size: 28px;
  font-weight: 600;

  ${mobile(css`
    font-size: 22px;
  `)};
`;

export const HowItWorksSubtitle = styled(Typography)`
  color: ${COLORS.LOGIN_SECONDARY};
  font-size: 15px;
  margin-top: 10px;
`;

export const HowItWorksList = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 980px;
  margin: 0 auto;

  ${mobile(css`
    gap: 24px;
  `)};
`;

export const StepRow = styled.div<{ reverse?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  ${mobile(css`
    flex-direction: column-reverse;
    text-align: center;
    gap: 16px;
  `)};
`;

export const StepTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 420px;
`;

export const StepTitle = styled(Typography)`
  color: ${COLORS.LOGIN_PRIMARY};
  font-size: 20px;
  font-weight: 600;

  ${mobile(css`
    font-size: 18px;
  `)};
`;

export const StepDescription = styled(Typography)`
  color: ${COLORS.LOGIN_SECONDARY};
  font-size: 14px;
  line-height: 1.5;
`;

export const StepVisual = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobile(css`
    width: 100px;
    height: 100px;
  `)};
`;

export const StepVisualBlob = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  border-radius: 45% 55% 60% 40% / 50% 45% 55% 50%;
  background: #eaf0ef;
`;

export const StepIconCircle = styled.div`
  position: relative;
  z-index: 1;
  width: 72%;
  height: 72%;
  border-radius: 50%;
  background: white;
  box-shadow: 0 12px 32px rgba(223, 79, 113, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
`;
